import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { designSystem } from '@yola/ws-ui';
import fieldNames from '../constants/field-names';
import validators from '../validators';

const { InputGroupField } = designSystem;

const IframeUrlControl = ({ control, onChange }) => {
  const name = fieldNames.IFRAME_URL;
  const rules = useMemo(
    () => ({
      validate: (value) => {
        const validator = validators.createIframeUrlValidator();

        return validator(value);
      },
    }),
    []
  );

  const handleChange = (value) => {
    onChange(value);
  };

  return (
    <div>
      <InputGroupField
        name={name}
        control={control}
        rules={rules}
        placeholder="https://www.youtube.com/watch?v=dQw4w9WgXcQ"
        onChange={handleChange}
      />
    </div>
  );
};

IframeUrlControl.propTypes = {
  control: PropTypes.shape({}).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default IframeUrlControl;
